import { db, storage } from "../../Helpers/firebase";
import { GET_ALL_CHAT, GET_FIREBASE_MSG } from "../actions";

import axios from "axios";

const PROXY = process.env.REACT_APP_URL + "api/";

export const readAllMessage = (data, length, userId) => async (dispatch) => {
  // console.log(data);

  const res = db
    .collection("messages")
    .doc(data)
    .collection(data)
    .where("groupId", "==", data)
    .where("flag", "==", 2)
    //.where("to", "==", userId)
    .get()
    .then((snap) => {
      snap.docs.forEach((doc) => {
        if (true == length) {
          let batch = db.batch();
          const ref = doc.ref;

          batch.update(ref, { fromUnread: 1 });
          return batch.commit();
        } else {
          return null;
        }
      });
    });
  return true;
};

export const getAllMessage = (data, userId) => async (dispatch, getState) => {
  const res = await db
    .collection("messages")
    .doc(data?.toString())
    .collection(data)
    .orderBy("timestamp", "asc")
    .onSnapshot((doc) => {
      let message = [];
      doc.forEach(async (s) => {
        message.push(s.data());
      });

      // db.collection("messages")
      //   .doc(data)
      //   .collection(data)
      //   .where("fromUnread", "==", 0)
      //   .where("groupId", "==", data)

      //   .where("to", "==", userId)
      //   .get()
      //   .then((snap) => {
      //     snap.docs.forEach((doc) => {
      //       let batch = db.batch();
      //       const ref = doc.ref;
      //       batch.update(ref, { fromUnread: 1 });
      //       return batch.commit();
      //     });
      //   });

      dispatch({
        type: GET_FIREBASE_MSG,
        payload: message,
      });
    });

  return res;
};

export const sendMessage = (data) => async (dispatch) => {
  try {
    const res = await db.collection("messages").doc(data.id).get();
    let newObj = {};

    newObj.from = data.from;
    newObj.message = data.message;
    newObj.to = data.to;
    newObj.timestamp = new Date();
    newObj.fromUnread = 0; // Unread = 0 and Read =1
    newObj.groupId = data.id;
    newObj.flag = 1;

    if (data.message) {
      newObj.type = "text";
    } else {
      newObj.type = "image";
    }

    if (res.exists) {
      let docRef = db.collection("messages").doc(data.id);
      await db.runTransaction(async (transaction) => {
        transaction.set(docRef, newObj);
      });

      await db
        .collection("messages")
        .doc(data.id)
        .collection(data.id)
        .doc(new Date().getTime().toString())
        .set(newObj);
    } else {
      let docRef = db.collection("messages").doc(data.id);
      await db.runTransaction(async (transaction) => {
        transaction.set(docRef, newObj);
      });

      await db
        .collection("messages")
        .doc(data.id)
        .collection(data.id)
        .doc(new Date().getTime().toString())
        .set(newObj);
    }
  } catch (err) {
    console.error(err);
  }
};

export const getAllChat = (search) => async (dispatch) => {
  try {
    let res = await axios.get(
      `${PROXY}chat/get-all-chat-staff?search=${search}`
    );
    // for (let i = 0; i < res.data.result.length; i++) {
    //   const element = res.data.result[i]

    // await db
    //   .collection('messages')
    //   .doc(element._id.toString())
    //   .onSnapshot(async (doc) => {
    //     element['last'] = await doc.data()
    //   })

    // await db
    //   .collection('messages')
    //   .doc(element._id?.toString())
    //   .collection(element._id)
    //   .orderBy('timestamp', 'asc')
    //   .onSnapshot((doc) => {
    //     let message = []
    //     doc.forEach(async (s) => {
    //       message.push(s.data())

    //       const unreads = message.filter((val) => val.fromUnread === 0)

    //       element['unreads'] = unreads.length
    //     })
    //   })

    // }

    dispatch({
      type: GET_ALL_CHAT,
      payload: res.data.result,
    });
    return res.data.result;
  } catch (err) {
    console.error(err);
  }
};

export const fileUpdateFB = (imageAsFile, data) => async (dispatch) => {
  const uploadTask = storage
    .ref(`/images/${imageAsFile.name}`)
    .put(imageAsFile);

  uploadTask.on(
    "state_changed",
    (snapShot) => {
      //takes a snap shot of the process as it is happening
    },
    (err) => {
      //catches the errors
    },
    () => {
      // gets the functions from storage refences the image storage in firebase by the children
      // gets the download url then sets the image from firebase as the value for the imgUrl key:
      storage
        .ref("images")
        .child(imageAsFile.name)
        .getDownloadURL()
        .then(async (fireBaseUrl) => {
          const res = await db.collection("messages").doc(data.id).get();
          let newObj = {};

          newObj.from = data.from;
          newObj.to = data.to;
          newObj.timestamp = new Date();
          newObj.image = fireBaseUrl;
          newObj.type = "image";
          newObj.fromUnread = 0; // Unread = 0 and Read =1
          newObj.groupId = data.id;
          newObj.flag = 1;

          if (res.exists) {
            let docRef = db.collection("messages").doc(data.id);
            await db.runTransaction(async (transaction) => {
              transaction.set(docRef, newObj);
            });
            await db
              .collection("messages")
              .doc(data.id)
              .collection(data.id)
              .doc(new Date().getTime().toString())
              .set(newObj);
          } else {
            let docRef = db.collection("messages").doc(data.id);
            await db.runTransaction(async (transaction) => {
              transaction.set(docRef, newObj);
            });
            await db
              .collection("messages")
              .doc(data.id)
              .collection(data.id)
              .doc(new Date().getTime().toString())
              .set(newObj);
          }
        });
    }
  );
};
